<template>
  <div>
    <!-- Toggle Button -->
    <button 
      @click="toggleChat" 
      class="fixed bottom-4 right-4 bg-blue-600 text-white p-3 rounded-full shadow-lg z-50"
    >
      {{ isOpen ? 'Close' : 'Pablo' }}
    </button>

    <!-- Chat Panel -->
    <div 
      v-if="isOpen" 
      class="fixed bottom-16 right-4 w-80 bg-white rounded-lg shadow-lg p-4 z-50 flex flex-col"
    >
      <!-- Message History -->
      <div class="overflow-y-auto h-64 mb-2 border-b border-gray-300 pb-2">
        <div 
          v-for="(msg, index) in messages" 
          :key="index" 
          class="mb-2"
        >
          <strong :class="msg.sender === 'pablo' ? 'text-purple-600' : 'text-green-600'">
            {{ msg.sender === 'pablo' ? 'Pablo:' : 'You:' }}
          </strong>
          {{ msg.text }}
        </div>
      </div>

      <!-- User Input -->
      <div class="flex">
        <input
          v-model="userInput"
          @keyup.enter="sendToPablo()"
          placeholder="Type your message..."
          class="flex-1 border border-gray-300 rounded p-2 mr-2"
        />
        <button @click="sendToPablo()" class="bg-green-600 text-white px-3 py-1 rounded">
          Send
        </button>
        <button @click="startListening" class="bg-purple-600 text-white px-3 py-1 rounded ml-2">
          🎙️
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'PabloAssistant',
  data() {
    return {
      isOpen: false,
      userInput: '',
      messages: [],
      sessionId: Date.now().toString()
    };
  },
  methods: {
    toggleChat() {
      this.isOpen = !this.isOpen;
    },
    async sendToPablo(inputParam) {
      let rawInput;
      if (typeof inputParam === 'string') {
        rawInput = inputParam;
      } else {
        rawInput = this.userInput;
      }
      const input = String(rawInput).trim();
      if (!input) return;

      this.messages.push({ sender: 'user', text: input });
      this.userInput = '';

      try {
        const response = await api.post('/api/pablo/ask', {
          sessionId: this.sessionId,
          step: null, // optional, if you want to manage steps
          userInput: input,
          context: {} // optional, add context if needed
        });

        const reply = response.data.reply;
        this.messages.push({ sender: 'pablo', text: reply });

        // Optional: Text-to-Speech
        const utterance = new SpeechSynthesisUtterance(reply);
        speechSynthesis.speak(utterance);
      } catch (error) {
        console.error("Error calling Pablo:", error);
        this.messages.push({ sender: 'pablo', text: "Sorry, I couldn’t get a response." });
      }
    },
    startListening() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        console.error("Speech recognition is not supported in this browser.");
        this.messages.push({ sender: 'pablo', text: "Speech recognition is not supported in this browser." });
        return;
      }

      const recognition = new SpeechRecognition();
      recognition.lang = 'en-US';

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        this.sendToPablo(transcript);
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error:", event.error);
        this.messages.push({ sender: 'pablo', text: "Sorry, I couldn't understand. Please try typing." });
      };

      recognition.start();
    }
  }
};
</script>

<style scoped>
.pablo-toggle-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  background-color: #327ba8;
  color: white;
  padding: 12px 16px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  cursor: pointer;
  border: none;
}
.pablo-toggle-button:hover {
  background-color: #286c98;
}

.pablo-chat-panel {
  position: fixed;
  bottom: 80px;
  right: 16px;
  width: 320px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  padding: 16px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.pablo-message-history {
  overflow-y: auto;
  max-height: 256px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.pablo-message {
  margin-bottom: 8px;
}

.pablo-sender {
  color: #800080; /* purple */
  font-weight: bold;
}

.user-sender {
  color: #008000; /* green */
  font-weight: bold;
}

.pablo-input-container {
  display: flex;
}

.pablo-input {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  margin-right: 4px;
}

.pablo-send-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 4px;
}

.pablo-send-button:hover {
  background-color: #218838;
}

.pablo-voice-button {
  background-color: #6f42c1;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.pablo-voice-button:hover {
  background-color: #5936a2;
}
</style>
